/**
 * Convert snake_case keys to camelCase recursively
 */
const snakeToCamel = (str: string): string => {
  return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
};

export const transformToCamelCase = (obj: any): any => {
  if (obj === null || obj === undefined) return obj;

  if (Array.isArray(obj)) {
    return obj.map(item => transformToCamelCase(item));
  }

  if (typeof obj === 'object') {
    const transformed: any = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const camelKey = snakeToCamel(key);
        transformed[camelKey] = transformToCamelCase(obj[key]);
      }
    }
    return transformed;
  }

  return obj;
};

/**
 * Safely transform block content payloads to camelCase
 * Handles report data structures from backend
 */
export const transformBlockContent = (blockContent: any): any => {
  if (!blockContent) return blockContent;

  const transformed = { ...blockContent };

  // Transform payload with special handling for nested structures
  if (transformed.payload) {
    const payload = transformed.payload;

    // Handle report data structures
    if (payload.data) {
      transformed.payload = {
        ...payload,
        data: transformToCamelCase(payload.data),
      };
    } else {
      transformed.payload = transformToCamelCase(payload);
    }
  }

  return transformed;
};
